module.exports = __webpack_public_path__ + "assets/images/atm.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/atm.png
// module id = 244
// module chunks = 1